export default Object.freeze({
    SMS: {
        label: 'SMS',
        value: 'SMS',
    },
    EMAIL: {
        label: 'EMAIL',
        value: 'EMAIL',
    },
    EMAIL_AND_SMS: {
        label: 'EMAIL/SMS',
        value: 'EMAIL_AND_SMS',
    },
    FREE_EMAIL: {
        label: 'FREE EMAIL',
        value: 'FREE_EMAIL',
    },
})
